export const praceTable = [
  { caption: 'Kol', get: (row) => row.id, align: 'right', id: true },
  { caption: 'Nazwa', get: (row) => row.nazwas, align: 'left', maximize: true },
  { caption: 'Brygada', get: (row) => row.worker, align: 'left' },
  { caption: 'Czas', get: (row) => row.czas, align: 'left' },
]
